import { useNavigate, useParams } from 'react-router-dom';
import NewProjectDialog from '@/pages/newProject/NewProjectDialog';

/**
 * The "הקמת פרויקט" sub-tab. The design draws the wizard as a modal, and the projects list
 * opens exactly the same modal from its "הוספה" button — so this page hosts that one component
 * rather than duplicating the flow, and returns to the list when the wizard is closed.
 */
const NewProjectPage = () => {
  const navigate = useNavigate();
  const { fundId } = useParams();

  const goToList = () => {
    navigate(`/${fundId}/projects/list`);
  };

  return (
    <NewProjectDialog
      open
      onClose={goToList}
      // The list refetches on mount, so nothing extra is needed once the project is submitted.
      onSuccess={() => {}}
    />
  );
};

export default NewProjectPage;
